(function () {
  'use strict';

  var header = document.querySelector('.eco-header');
  if (!header) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- sticky ----------
     Shrinking the header shortens the document, which can nudge scrollY back
     under the trigger point - the header then grows, crosses the point again,
     and flickers. Three separate guards stop that:

     1. Two thresholds (stick at N, release at N-70) give the state a dead zone.
     2. A minimum interval between flips. Even if something outside this file
        moves the scroll position, the class cannot thrash faster than this.
     3. overflow-anchor:none on the sticky section. The header changes height
        when it sticks (shorter bar, smaller logo, category chips hidden), and
        the browser's scroll anchoring compensates for size changes above the
        viewport by adjusting scrollY -- which is what pushes the position back
        across the threshold in the first place. Opting the header out of
        anchoring removes the feedback loop at its source. Set here rather than
        in CSS so it stays next to the logic it protects. */
  if (header.dataset.sticky === 'true') {
    var stickAt = parseInt(header.dataset.stickyThreshold, 10) || 90;
    var releaseAt = Math.max(stickAt - 70, 8);
    var MIN_TOGGLE_INTERVAL = 400;
    var lastToggleAt = 0;
    var ticking = false;
    var isStuck = false;

    var section = header.closest('.shopify-section');
    if (section) section.style.overflowAnchor = 'none';

    var evaluate = function () {
      var y = window.scrollY || window.pageYOffset || 0;
      var next = isStuck;

      if (!isStuck && y > stickAt) {
        next = true;
      } else if (isStuck && y < releaseAt) {
        next = false;
      }

      if (next !== isStuck) {
        var now = Date.now();
        if (now - lastToggleAt < MIN_TOGGLE_INTERVAL) {
          ticking = false;
          return;
        }
        lastToggleAt = now;
        isStuck = next;
        header.classList.toggle('is-stuck', isStuck);
        if (!isStuck) {
          header.classList.remove('search-open');
          if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
        }
      }
      ticking = false;
    };

    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(evaluate);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    evaluate();
  }

  /* ---------- drawer ---------- */
  var drawer = document.getElementById('EcoDrawer');
  var scrim = document.getElementById('EcoScrim');
  var burger = document.getElementById('EcoBurger');
  var closeBtn = document.getElementById('EcoDrawerClose');
  var lastFocus = null;

  /* The closed drawer holds ~40 tabbable links. It used to be marked
     aria-hidden="true", which removed it from the accessibility tree while
     leaving every one of those links in the tab order -- a contradiction that
     fails axe's aria-hidden-focus rule and was the single audit failing
     Lighthouse's Agentic Browsing category.

     `inert` is now the only mechanism: it takes the subtree out of the tab
     order, out of hit-testing AND out of the accessibility tree, all at once.
     Deliberately no aria-hidden alongside it -- pairing the two leaves the
     audit dependent on whether the checker understands inert, whereas with no
     aria-hidden present the rule has nothing to fire on at all. */
  if (drawer) {
    drawer.removeAttribute('aria-hidden');
    if (!drawer.classList.contains('is-open')) drawer.setAttribute('inert', '');
  }

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    // Un-inert before moving focus inside, or the focus call is a no-op.
    drawer.removeAttribute('inert');
    if (scrim) scrim.classList.add('is-open');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (scrim) scrim.classList.remove('is-open');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    // Move focus back out first: if the subtree goes inert while focus is still
    // inside it, the browser drops focus to <body> and the trigger loses place.
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    drawer.setAttribute('inert', '');
  }

  if (burger) burger.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (scrim) scrim.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer && drawer.classList.contains('is-open')) closeDrawer();
    closeSuggest();
    closeAllDropdowns();
    if (header.classList.contains('search-open')) {
      header.classList.remove('search-open');
      if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
    }
  });

  document.addEventListener('focusin', function (e) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    if (!drawer.contains(e.target)) {
      e.stopPropagation();
      if (closeBtn) closeBtn.focus();
    }
  });

  /* ---------- drawer submenus ---------- */
  Array.prototype.forEach.call(document.querySelectorAll('.eco-drow[data-toggle]'), function (btn) {
    btn.addEventListener('click', function () {
      var panel = btn.nextElementSibling;
      if (!panel) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (open) {
        panel.style.height = panel.scrollHeight + 'px';
        panel.offsetHeight;
        panel.style.transition = reduce ? 'none' : 'height .26s cubic-bezier(.2,.7,.3,1)';
        panel.style.height = '0px';
        window.setTimeout(function () { panel.hidden = true; panel.style.height = ''; panel.style.transition = ''; }, reduce ? 0 : 270);
      } else {
        panel.hidden = false;
        var h = panel.scrollHeight;
        panel.style.height = '0px';
        panel.offsetHeight;
        panel.style.transition = reduce ? 'none' : 'height .26s cubic-bezier(.2,.7,.3,1)';
        panel.style.height = h + 'px';
        window.setTimeout(function () { panel.style.height = ''; panel.style.transition = ''; }, reduce ? 0 : 280);
      }
    });
  });

  /* ---------- desktop dropdowns ---------- */
  function closeAllDropdowns(except) {
    Array.prototype.forEach.call(document.querySelectorAll('.eco-dd.is-open'), function (dd) {
      if (dd !== except) {
        dd.classList.remove('is-open');
        var t = dd.previousElementSibling;
        if (t && t.setAttribute) t.setAttribute('aria-expanded', 'false');
      }
    });
  }

  Array.prototype.forEach.call(document.querySelectorAll('.eco-nav__link[aria-haspopup]'), function (link) {
    link.addEventListener('click', function (e) {
      if (!window.matchMedia('(hover: none)').matches) return;
      var dd = link.nextElementSibling;
      if (!dd) return;
      e.preventDefault();
      var open = dd.classList.contains('is-open');
      closeAllDropdowns();
      if (!open) {
        dd.classList.add('is-open');
        link.setAttribute('aria-expanded', 'true');
      }
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (!e.target.closest('.eco-nav__item')) closeAllDropdowns();
    if (!e.target.closest('.eco-search') && !e.target.closest('.eco-act--search')) {
      closeSuggest();
      if (header.classList.contains('search-open') && input && !input.value.trim()) {
        header.classList.remove('search-open');
        if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
      }
    }
  });

  /* ---------- search ---------- */
  var searchRoot = document.getElementById('EcoSearch');
  var input = searchRoot ? searchRoot.querySelector('input[name="q"]') : null;
  var sugg = document.getElementById('EcoSuggest');
  var clearBtn = searchRoot ? searchRoot.querySelector('.eco-search__clear') : null;
  var searchToggle = document.getElementById('EcoSearchToggle');
  var timer = null;
  var controller = null;
  var cache = {};

  function closeSuggest() {
    if (sugg) sugg.classList.remove('is-open');
  }

  if (searchToggle) {
    searchToggle.addEventListener('click', function () {
      var open = header.classList.toggle('search-open');
      searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && input) {
        window.setTimeout(function () { input.focus(); }, 60);
      } else {
        closeSuggest();
      }
    });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function render(items, q) {
    if (!sugg) return;
    if (!items.length) {
      sugg.innerHTML = '<p class="eco-sugg__empty">No matches for &ldquo;' + esc(q) + '&rdquo;</p>';
      sugg.classList.add('is-open');
      return;
    }
    var sym = searchRoot.dataset.currency || '';
    var html = '<p class="eco-sugg__label">Products</p>';
    items.forEach(function (p) {
      var img = p.image ? '<img src="' + esc(p.image) + '" alt="" width="46" height="46" loading="lazy">' : '<span class="eco-sugg__ph"></span>';
      var price = p.price ? '<span class="eco-sugg__p">' + sym + esc(p.price) + '</span>' : '';
      html += '<a href="' + esc(p.url) + '">' + img + '<span><span class="eco-sugg__t">' + esc(p.title) + '</span>' + price + '</span></a>';
    });
    html += '<a class="eco-sugg__all" href="' + esc(searchRoot.dataset.searchUrl || '/search') + '?q=' + encodeURIComponent(q) + '">View all results</a>';
    sugg.innerHTML = html;
    sugg.classList.add('is-open');
  }

  function query(q) {
    if (cache[q]) { render(cache[q], q); return; }
    if (controller) controller.abort();
    controller = new AbortController();
    var base = searchRoot.dataset.suggestUrl || '/search/suggest';
    var url = base + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url, { signal: controller.signal })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = ((data.resources || {}).results || {}).products || [];
        cache[q] = products;
        render(products, q);
      })
      .catch(function () {});
  }

  if (input) {
    input.addEventListener('input', function () {
      var q = input.value.trim();
      searchRoot.classList.toggle('has-value', q.length > 0);
      window.clearTimeout(timer);
      if (q.length < 2) { closeSuggest(); return; }
      timer = window.setTimeout(function () { query(q); }, 220);
    });
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && sugg && sugg.innerHTML) sugg.classList.add('is-open');
    });
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      input.value = '';
      searchRoot.classList.remove('has-value');
      closeSuggest();
      input.focus();
    });
  }

  /* ---------- cart count ---------- */
  function paintCount(n) {
    Array.prototype.forEach.call(document.querySelectorAll('.eco-count'), function (el) {
      el.textContent = n > 99 ? '99+' : n;
      el.hidden = n < 1;
    });
  }

  function refreshCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { paintCount(c.item_count); })
      .catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.action && form.action.indexOf('/cart/add') > -1) {
      window.setTimeout(refreshCart, 700);
    }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[name="add"], .quick-add__submit') : null;
    if (btn) window.setTimeout(refreshCart, 900);
  });

  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });
})();
